import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { stateAbbreviations, formatDate } from '../../../common/utils';
import { Typeahead } from 'react-bootstrap-typeahead';
import { createContact } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';

const AddContact = ( { close, user, orgId, uid, settings, viewing, createFields, pSource, pStatus, pStage, pPurpose, pOccupation, contacts } ) => {
    const nav = useNavigate();

    const [ name, setName ] = useState();
    const [ firstname, setFirstName ] = useState();
    const [ lastname, setLastName ] = useState();
    const [ email, setEmail ] = useState();
    const [ phoneMobile, setPhoneMobile ] = useState();
    const [ purpose, setPurpose ] = useState();
    const [ status, setStatus ] = useState();
    const [ stage, setStage ] = useState();
    const [ occupation, setOccupation ] = useState();
    const [ hasAddr, setShowAddr ] = useState( false );
    const [ addr, setAddr ] = useState();
    const [ city, setCity ] = useState();
    const [ state, setState ] = useState();
    const [ zip, setZip ] = useState();
    const [ role, setRole ] = useState( '' );
    const [ source, setSource ] = useState();
    const [ referral, setReferral ] = useState();
    const [ singleSelections, setSingleSelections ] = useState( [] );
    const [ hasOfficeAddr, setShowOfficeAddr ] = useState( false );
    const [ officeAddr, setOfficeAddr ] = useState();
    const [ officeCity, setOfficeCity ] = useState();
    const [ officeState, setOfficeState ] = useState();
    const [ officeZip, setOfficeZip ] = useState();
    const [ company, setCompany ] = useState();
    const [ team, setTeam ] = useState();
    const [ processing, setProcessing ] = useState( false );
    const [ searchList, setSearchList ] = useState( [] );
    const [ partnerList, setPartnerList ] = useState( [] );
    const [ hasCobo, setShowCobo ] = useState( false );
    const [ firstnameCobo, setFirstNameCobo ] = useState();
    const [ lastnameCobo, setLastNameCobo ] = useState();
    const [ emailCobo, setEmailCobo ] = useState();
    const [ phoneMobileCobo, setPhoneMobileCobo ] = useState();
    const [ interestedCities, setInterestedCities ] = useState();
    const [ origSourceDetails, setOrigSourceDetails ] = useState();
    
    // const [ dupEmails, setDupEmails ] = useState( [] );
    // const [ dupPhones, setDupPhones ] = useState( [] );

    const create = async () => {
        setProcessing( true );
        const now = new Date();
        const sharePartners = ( user && user.org && user.org.sharePartners === true ) ? true : false;
        const seg = ( role === 'partner' && sharePartners ) ? 'create-org-contact' : 'create-contact';

        const contact = {
            name: name,
            purpose: purpose,
            status: status,
            stage: stage,
            homeAddress1: addr,
            homeCity: city,
            homeState: state,
            homeZip: zip,
            firstname: firstname,
            lastname: lastname,
            email: email,
            phoneMobile: phoneMobile,
            occupation: occupation,
            priRole: role,
            origSource: source,
            referredById: referral,
            workAddress1: officeAddr,
            workCity: officeCity,
            workState: officeState,
            workZip: officeZip,
            employer: company,
            team: team,
            oppDate: formatDate( now ),
            interestedCities: interestedCities,
            origSourceDetails: origSourceDetails
        };

        let cobo;
        if ( hasCobo ) {
            let cbName = firstnameCobo + ' ' + lastnameCobo;
            cbName = cbName.trim(); 
            
            if ( settings?.contact?.coboAsPartner === true ) {
                contact.namePartner1 = cbName;
                contact.firstnamePartner1 = firstnameCobo;
                contact.lastnamePartner1 = lastnameCobo;
                contact.emailPartner1 = emailCobo;
                contact.phonePartner1 = phoneMobileCobo;
            } else {
                cobo = {
                    name: cbName,
                    purpose: purpose,
                    status: status,
                    stage: stage,
                    homeAddress1: addr,
                    homeCity: city,
                    homeState: state,
                    homeZip: zip,
                    firstname: firstnameCobo,
                    lastname: lastnameCobo,
                    email: emailCobo,
                    phoneMobile: phoneMobileCobo,
                    priRole: role,
                    origSource: source,
                    referredById: referral,
                    oppDate: formatDate( now ),
                    interestedCities: interestedCities
                };
            }
        }

        const added = await createContact( orgId, viewing[0], uid, contact, seg, cobo );
        if ( added.length ) {
            toast.success( `${firstname} is now a contact in the system for ${viewing[0]}`, { theme: 'dark' } );
            close();
            nav( `/contact/${added[0]}` );
        }
    }

    useEffect( () => {
        let list = [];
        let biz = [];
        const sharePartners = ( user && user.org && user.org.sharePartners === true ) ? true : false;

        if ( contacts ) {
            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];

                if ( viewing.includes( c.aid ) || ( c.priRole === 'partner' && sharePartners ) ) {
                    list.push( {
                        id: c.cid,
                        cid: c.cid,
                        firstname: c.firstname,
                        lastname: c.lastname,
                        name: c.name,
                        email: c.email,
                        email2: c.email2,
                        phone: c.phone,
                        phoneMobile: c.phoneMobile,
                        phoneWork: c.phoneWork,
                        firstnamePartner1: c.firstnamePartner1,
                        lastnamePartner1: c.lastnamePartner1,
                        emailPartner1: c.emailPartner1,
                        phonePartner1: c.phonePartner1,
                        firstnamePartner2: c.firstnamePartner2,
                        lastnamePartner2: c.lastnamePartner2,
                        emailPartner2: c.emailPartner2,
                        phonePartner2: c.phonePartner2,
                        team: c.team,
                        employer: c.employer,
                        priRole: c.priRole
                    } );

                    if ( c.priRole === 'partner' ) {
                        biz.push( {
                            id: c.cid,
                            cid: c.cid,
                            firstname: c.firstname,
                            lastname: c.lastname,
                            name: c.name,
                            email: c.email,
                            phone: c.phone,
                            phoneMobile: c.phoneMobile,
                            phoneWork: c.phoneWork,
                            team: c.team,
                            employer: c.employer
                        } );
                    }
                }
            } );
        }
        setSearchList( list );
        setPartnerList( biz );
    }, [ contacts, uid, viewing, user ] );

    useEffect( () => {
        let tmp = {};

        tmp = pSource.find( p => p.default );
        setSource( tmp ? tmp.value : pSource[0].value );

        tmp = pPurpose.find( p => p.default );
        setPurpose( tmp ? tmp.value : pPurpose[0].value );

        tmp = pStatus.filter( f => f.object.includes( 'contact' ) ).find( p => p.default );
        const stat = ( tmp ) ? tmp.value : pStatus.filter( f => f.object.includes( 'contact' ) )[0].value;
        setStatus( stat );

        if ( pStage ) {
            tmp = pStage.find( p => p.default );
            setStage( tmp ? tmp.value : pStage[0].value );
        }
    }, [ pSource, pPurpose, pStatus, pStage ] );

    useEffect( () => {
        if ( role === 'partner' ) {
            const tmp = pOccupation.find( p => p.default );
            setOccupation( tmp ? tmp.value : pOccupation[0].value );
        } else {
            setOccupation();
        }
    }, [ role, pOccupation ] );

    useEffect( () => {
        if ( singleSelections.length ) {
            setReferral( singleSelections[0].cid );
        } else {
            setReferral();
        }
    }, [ singleSelections ] );

    useEffect( () => {
        let fn = firstname;
        fn += ( firstname?.length && lastname?.length ) ? ' ' : '';
        fn += ( lastname?.length ) ? lastname : '';
        setName( fn );
    }, [ firstname, lastname ] );

    return (
        <Fragment>
            <Modal.Header closeButton>
                <Modal.Title>Create a New Contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                processing ? (
                    <Fragment>
                        <Row className='py-3'>
                            <Col className='text-center'>
                                <Spinner animation="border" variant='primary' role="status" />
                            </Col>
                        </Row>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control className='tf-modal-text-input' type='text' id='firstname' value={firstname} onChange={ ( e ) => setFirstName( e.target.value ) } />
                                </Form.Group>
                            </Col>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control className='tf-modal-text-input' type='text' id='lastname' value={lastname} onChange={ ( e ) => setLastName( e.target.value ) } />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control className='tf-modal-text-input' type='email' id='email' value={email} onChange={ ( e ) => setEmail( e.target.value ) } />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Mobile Phone</Form.Label>
                                    <Form.Control className='tf-modal-text-input' type='phone' id='phoneMobile' value={phoneMobile} onChange={ ( e ) => setPhoneMobile( e.target.value ) } />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Source</Form.Label>
                                    <Form.Select size='sm' className='tf-modal-text-input' value={source} onChange={ ( e ) => setSource( e.target.value ) }>
                                        <option key='add-contact-empty-source' value=''>Not Set</option>
                                        {
                                            pSource.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {
                                source?.match( /refer/i ) ? (
                                    <Col xs='auto'>
                                        <Form.Group>
                                            <Form.Label>Referred By</Form.Label>
                                            <Typeahead
                                                filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                                id="tf-contact-referral-finder"
                                                labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                                onChange={setSingleSelections}
                                                selected={singleSelections}
                                                options={ searchList }
                                                placeholder="Search Contacts..."
                                                renderMenuItemChildren={ ( option ) => (
                                                    <div>
                                                        {option.firstname + ' ' + option.lastname}
                                                        <div>
                                                            <small>Email: {option.email}</small>
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                ) : (
                                    <Fragment />
                                )
                            }
                            {
                                source?.match( /realtor.com/i ) ? (
                                    <>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Primary Location</Form.Label>
                                                <Form.Control className='tf-modal-text-input' type='text' id='interestedCities' value={interestedCities} onChange={ ( e ) => setInterestedCities( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Realtor Partner</Form.Label>
                                                <Typeahead
                                                    filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                                    id="tf-contact-referral-finder"
                                                    labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                                    onChange={setSingleSelections}
                                                    selected={singleSelections}
                                                    options={ partnerList }
                                                    placeholder="Search Partners..."
                                                    renderMenuItemChildren={ ( option ) => (
                                                        <div>
                                                            {option.firstname + ' ' + option.lastname}
                                                            <div>
                                                                <small>Email: {option.email}</small>
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                ) : (
                                    <Fragment />
                                )
                            }{
                                source?.match( /purchased lead/i ) ? (
                                    <>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>From</Form.Label>
                                                <Form.Control className='tf-modal-text-input' type='text' id='origSourceDetails' value={origSourceDetails} onChange={ ( e ) => setOrigSourceDetails( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Realtor Partner</Form.Label>
                                                <Typeahead
                                                    filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                                    id="tf-contact-referral-finder"
                                                    labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                                    onChange={setSingleSelections}
                                                    selected={singleSelections}
                                                    options={ partnerList }
                                                    placeholder="Search Partners..."
                                                    renderMenuItemChildren={ ( option ) => (
                                                        <div>
                                                            {option.firstname + ' ' + option.lastname}
                                                            <div>
                                                                <small>Email: {option.email}</small>
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                ) : (
                                    <Fragment />
                                )
                            }
                        </Row>
                        <Row className='py-2'>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Primary Role to You</Form.Label>
                                    <Row>
                                        <Col xs='auto'><Form.Check
                                            inline
                                            label="a Borrower"
                                            name='role'
                                            type='radio'
                                            id='borrower'
                                            onChange={ ( e ) => setRole( 'borrower' ) }
                                        /></Col>
                                        <Col xs='auto'><Form.Check
                                            inline
                                            label='a Business Partner'
                                            name='role'
                                            type='radio'
                                            id='partner'
                                            onChange={ ( e ) => setRole( 'partner' ) }
                                        /></Col>
                                        {
                                            user.aid === 'TeamHunter' ? (
                                                <Col xs='auto'><Form.Check
                                                    inline
                                                    label='an Associate'
                                                    name='role'
                                                    type='radio'
                                                    id='associate'
                                                    onChange={ ( e ) => setRole( 'associate' ) }
                                                /></Col>
                                            ) : (
                                                null
                                            )
                                        }
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                            ( role === 'borrower' ) ? (
                                <Fragment>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Current Intent</Form.Label>
                                                <Form.Select size='sm' className='tf-modal-text-input' value={purpose} onChange={ ( e ) => setPurpose( e.target.value ) }>
                                                    {
                                                        pPurpose.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Current Status</Form.Label>
                                                <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                                    {
                                                        pStatus.filter( f => f.object.includes( 'contact' ) ).map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                        ( pStage && pStage.length ) ? (
                                            <Row className='py-2'>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Current Stage</Form.Label>
                                                        <Form.Select size='sm' className='tf-modal-text-input' value={stage} onChange={ ( e ) => setStage( e.target.value ) }>
                                                            {
                                                                pStage.filter( f => f.object.includes( 'contact' ) ).map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        ) : (
                                            null
                                        )
                                    }
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Do you know where {firstname} lives?</Form.Label>
                                                <Form.Check type='switch' id='addr-switch' label='Yes' onChange={ ( e ) => setShowAddr( !hasAddr ) } />
                                            </Form.Group>
                                        </Col>
                                        {
                                            hasAddr ? (
                                                <Container fluid>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Street</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='addr-street' value={addr} onChange={ ( e ) => setAddr( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>City</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='addr-city' value={city} onChange={ ( e ) => setCity( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>State</Form.Label>
                                                                <Form.Select size='sm' className='tf-modal-text-input' value={state} onChange={ ( e ) => setState( e.target.value ) }>
                                                                    {
                                                                        stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                                                    }
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col style={ { maxWidth: '100px' } }>
                                                            <Form.Group>
                                                                <Form.Label>Zip</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='addr-zip' value={zip} onChange={ ( e ) => setZip( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            ) : (
                                                <Fragment />
                                            )
                                        }
                                    </Row>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Will there be a co-borrower you'd like to add now?</Form.Label>
                                                <Form.Check type='switch' id='addr-switch' label='Yes' onChange={ ( e ) => setShowCobo( !hasCobo ) } />
                                            </Form.Group>
                                        </Col>
                                        {
                                            hasCobo ? (
                                                <Container fluid>
                                                    <Row className='py-2'>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>Co-Borrower's First Name</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='firstnameCobo' value={firstnameCobo} onChange={ ( e ) => setFirstNameCobo( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>Co-Borrower's Last Name</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='lastnameCobo' value={lastnameCobo} onChange={ ( e ) => setLastNameCobo( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row className='py-2'>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>Co-Borrower's Email</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='email' id='emailCobo' value={emailCobo} onChange={ ( e ) => setEmailCobo( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row className='py-2'>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>Co-Borrower's Mobile Phone</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='phone' id='phoneMobileCobo' value={phoneMobileCobo} onChange={ ( e ) => setPhoneMobileCobo( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            ) : (
                                                <Fragment />
                                            )
                                        }
                                    </Row>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                                        </Col>
                                        <Col xs='auto'>
                                            <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                        </Col>
                                    </Row>
                                </Fragment>
                            ) : (
                                <Fragment />
                            )
                        }
                        {
                            ( role === 'partner' ) ? (
                                <Fragment>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Company</Form.Label>
                                                <Form.Control className='tf-modal-text-input' type='text' id='company' value={company} onChange={ ( e ) => setCompany( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Occupation</Form.Label>
                                                <Form.Select size='sm' className='tf-modal-text-input' value={occupation} onChange={ ( e ) => setOccupation( e.target.value ) }>
                                                    {
                                                        pOccupation.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {
                                            ( occupation === 'Realtor' ) ? (
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>Team Name?</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type='text' id='team' value={team} onChange={ ( e ) => setTeam( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            ) : (
                                                <Fragment />
                                            )
                                        }
                                    </Row>
                                    <Row className='py-2'>
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Do you know where {firstname} works?</Form.Label>
                                                <Form.Check type='switch' id='addr-switch' label='Yes' onChange={ ( e ) => setShowOfficeAddr( !hasOfficeAddr ) } />
                                            </Form.Group>
                                        </Col>
                                        {
                                            hasOfficeAddr ? (
                                                <Container fluid>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Street</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='office-addr-street' value={officeAddr} onChange={ ( e ) => setOfficeAddr( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>City</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='aoffice-ddr-city' value={officeCity} onChange={ ( e ) => setOfficeCity( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs='auto'>
                                                            <Form.Group>
                                                                <Form.Label>State</Form.Label>
                                                                <Form.Select size='sm' className='tf-modal-text-input' value={officeState} onChange={ ( e ) => setOfficeState( e.target.value ) }>
                                                                    {
                                                                        stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                                                    }
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col style={ { maxWidth: '100px' } }>
                                                            <Form.Group>
                                                                <Form.Label>Zip</Form.Label>
                                                                <Form.Control className='tf-modal-text-input' type='text' id='office-addr-zip' value={officeZip} onChange={ ( e ) => setOfficeZip( e.target.value ) } />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            ) : (
                                                <Fragment />
                                            )
                                        }
                                    </Row>
                                    <Row className='py-2'>
                                        <Col>
                                            <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                                        </Col>
                                    </Row>
                                </Fragment>
                            ) : (
                                <Fragment />
                            )
                        }
                        {
                            ( role === 'associate' ) ? (
                                <Fragment>
                                    <Row className='py-2'>
                                        <Col>
                                            <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                                        </Col>
                                    </Row>
                                </Fragment>
                            ) : (
                                <Fragment />
                            )
                        }
                    </Fragment>
                )
            }
            </Modal.Body>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    orgId: state.user.orgId,
    // aid: state.user.aid,
    uid: state.user.email,
    settings: state.user.meta.settings,
    viewing: state.user.viewing,
    createFields: state.user.meta.contact.create,
    pSource: state.user.meta.global.picklist.source,
    pStatus: state.user.meta.global.picklist.status,
    pStage: state.user.meta.global.picklist.stage,
    pPurpose: state.user.meta.global.picklist.purpose,
    pOccupation: state.user.meta.global.picklist.occupation,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( AddContact );